import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  ChartDropdownDimensionEnum,
  FEATURE_INFO_DICTIONARY,
  selectCurrChartDimension,
  setCurrChartDimension,
} from '../../services/data/impl/cube/cubeSlice';
import { useFeatureFlags } from '../../services/featureFlags/hooks/useFeatureFlags';
import { isFeatureEnum } from '../commonUtils';
import useIsBlueberryFeature from '../scanDataApi/hooks/useIsBlueberryFeature';
import { selectCurrFeature } from '../select/selectSlice';
import { ChartActions } from './ChartActions';
import CubeDropdown from './CubeDropdown';
import { AllPossibleActions } from './hooks/useChartActions';

type Props = {
  // TODO: Make this non-optional once we have removed RanchAreaHeader_Deprecated
  onChartAction?: (action: AllPossibleActions) => void;
};
const ChartHeader = ({ onChartAction }: Props) => {
  const dispatch = useAppDispatch();
  const currFeature = useAppSelector(selectCurrFeature);
  const currChartDimension = useAppSelector(selectCurrChartDimension);
  const { Diagnostics } = useFeatureFlags();
  const isBlueberry = useIsBlueberryFeature();

  const [dimensionOptions, setDimensionOptions] = useState<
    ChartDropdownDimensionEnum[]
  >([]);

  useEffect(() => {
    const isValidFeature = isFeatureEnum(currFeature);
    if (!isValidFeature) return;

    const newDimensionOptions = FEATURE_INFO_DICTIONARY[currFeature]?.map(
      (options) => options.dimension
    );

    // if not blueberry remove the perRowside option, unless enabled by Diagnostics
    if (!isBlueberry && !Diagnostics) {
      const perRowsideIndex = newDimensionOptions.indexOf(
        ChartDropdownDimensionEnum.perRowside
      );
      if (perRowsideIndex !== -1) {
        newDimensionOptions.splice(perRowsideIndex, 1);
      }
    }

    setDimensionOptions(newDimensionOptions);
    // If the current dimension is not in the new dimension options, set the current dimension to the first option
    if (!newDimensionOptions.includes(currChartDimension)) {
      dispatch(setCurrChartDimension(newDimensionOptions[0]));
    }
  }, [currFeature, currChartDimension, Diagnostics, isBlueberry, dispatch]);

  const handleChartActions = (actionId: AllPossibleActions) => {
    onChartAction?.(actionId);
  };

  return (
    <motion.div
      layout
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '1rem',
        paddingLeft: '1rem',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <CubeDropdown
          type='ChartDimension'
          value={currChartDimension}
          items={dimensionOptions}
        />
        {currChartDimension ===
          ChartDropdownDimensionEnum.colorDistribution && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              ml: 3,
            }}
          ></Box>
        )}
      </div>
      <ChartActions onAction={handleChartActions} />
    </motion.div>
  );
};

export default ChartHeader;
